import React, { useState, useEffect, Suspense } from 'react'
import { Canvas } from 'react-three-fiber'
import { EffectComposer, DepthOfField, Bloom, Noise, Vignette } from 'react-postprocessing'
import { Environment, Loader} from '@react-three/drei'
import Model from './components/three/Spheres'
import Controller from './components/react/Controller'
import { useGlobalStateContext, useGlobalDispatchContext } from './context/globalContext'
import { SLIDE_INC, SLIDE_DEC, SLIDE_TYPE, START, END } from './context/actions'
export default function App() {
  const [visible, setVisible] = useState(false)
  const { current, slideType } = useGlobalStateContext()
  const dispatch = useGlobalDispatchContext()
  const onNextClick = (type) => {    
    if (type === 'down') {
      if (current < 5) {
        dispatch({ type: SLIDE_TYPE, slideType: 'next' })
        dispatch({ type: SLIDE_INC })
      } else {
        dispatch({ type: SLIDE_INC })
        if (current == 6) dispatch({ type: START })
      }
    } else if (type == 'up') {
      if (current > 1) {
        dispatch({ type: SLIDE_TYPE, slideType: 'prev' })
        dispatch({ type: SLIDE_DEC })
      }else if(current==1){
        dispatch({ type: END })
      }
    }
  }
  const listOutline = ['API', 'R&D', 'RELIABLE', 'OUR', 'WORLD', 'API']
  const listDark = ['PRODUCTS', 'INNOVATION', 'SERVICE', 'HISTORY', 'SITES', 'PRODUCTS']
  useEffect(() => {
    document.title = "Sterling | Home"
    setTimeout(() => {
      setVisible(true)
    }, 2000)
  }, [])
  return (
    <>
      <div className="header">
        <h1>STERLING</h1>
      </div>
      <Canvas
        colorManagement
        camera={{ fov: 20, far: 1000, near: 0.001 }}
        gl={{ powerPreference: 'high-performance', alpha: false, antialias: false, stencil: false, depth: true }}
      >
        <color attach="background" args={['#050505']} />
        <fog color="#161616" attach="fog" near={1} far={40} />
        <Suspense fallback={null}>
          <Model slide={current} type={slideType} />          
        </Suspense>
        <EffectComposer>
            <DepthOfField focusDistance={0} focalLength={-1} bokehScale={2} height={200} />
            <Bloom luminanceThreshold={0} luminanceSmoothing={1} height={300} opacity={1} />
            <Noise opacity={0.025} />
            <Vignette eskil={false} offset={-0.1} darkness={1.4} />
          </EffectComposer>                
      </Canvas>      
      <div className="heading-container">
        <div className="lists">
          <ul className="outline">
            {listOutline.map((li, index) => (
              <li key={index} className={current == index + 1 ? 'active' : `inactive ${visible ? '' : 'invisible'}`}>
                {li}
              </li>
            ))}
          </ul>
          <hr />
          <ul className="dark">
            {listDark.map((li, index) => (
              <li key={index} className={current == index + 1 ? 'active' : `inactive ${visible ? '' : 'invisible'}`}>
                {li}
              </li>
            ))}
          </ul>
        </div>
        <Controller onNextClick={onNextClick} />
      </div>
    </>
  )
}
